function getCookieItem(name: string) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? decodeURIComponent(match[2]) : null
}

export function getCookieConsent() {
  let raw = getCookieItem('cookie_consent_level')

  if (!raw) {
    raw = localStorage.getItem('cookie_consent_level')
  }

  if (!raw) return null

  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function isMarketingAllowed() {
  const consent = getCookieConsent()
  return consent?.targeting === true
}

export function isAnalyticsAllowed() {
  const consent = getCookieConsent()
  return consent?.performance === true
}
